// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__IU2Vk","link":"NotFound_link__NdpBE"};